"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataType = exports["default"] = void 0;

var _wdh = require("@demant/wdh");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The supported types in schemas.
 */
var DataType = {
  IMAGE: 'image',
  MOBILE_IMAGE: 'mobileImage',
  VIDEO: 'video',
  IFRAME: 'iframe',
  HTML: 'html',
  LINK: 'link',
  LIST: 'list',
  TEXT: 'text',
  SCREENING_TEST_LIST: 'screeningTestList',
  IMAGE_SPOT_LIST: 'imageSpotList',
  NEWS_LIST_SPOT: 'newsListSpot',
  LINK_LIST: 'linkList',
  LANGUAGES_LIST: 'languagesList',
  SEARCH: 'search',
  BLOG_CATEGORIES: 'blogCategories',
  BLOG_LIST: 'blogList',
  RELATED_LIST: 'relatedList',
  AUTHOR_RELATED_BLOGS: 'authorRelatedBlogs',
  NAVIGATION: 'navigation',
  SEARCH_FIELD_SPOT: 'searchFieldSpot',
  LANGUAGE_SELECTOR_SPOT: 'languageSelectorSpot'
};
exports.DataType = DataType;

var ComponentDataParser = /*#__PURE__*/function () {
  function ComponentDataParser(component, schemaData) {
    _classCallCheck(this, ComponentDataParser);

    this.component = component;
    this.schemaData = schemaData;
  }

  _createClass(ComponentDataParser, [{
    key: "getComponentData",
    value: function getComponentData() {
      var _this = this;

      var schema = this.schemaData;
      var data = {};
      Object.keys(schema).forEach(function (key) {
        if ({}.hasOwnProperty.call(schema, key)) {
          var _schema$key = schema[key],
              name = _schema$key.name,
              element = _schema$key.element,
              elements = _schema$key.elements,
              type = _schema$key.type,
              parser = _schema$key.parser;
          var selectedElement = element ? _this.component.querySelector(element) : _this.component;
          selectedElement = elements ? Array.from(_this.component.querySelectorAll(elements)) : selectedElement;
          var elementData;

          if (selectedElement !== null && selectedElement !== undefined) {
            elementData = parser ? parser(selectedElement) : ComponentDataParser.getElementDataByType(type, selectedElement);
          } else {
            elementData = null;
          }

          data[name] = elementData;
        }
      });
      return data;
    }
  }], [{
    key: "getElementDataByType",
    value: function getElementDataByType(type, element) {
      var typesMap = {};
      typesMap[DataType.IMAGE] = ComponentDataParser.getComponentImage;
      typesMap[DataType.MOBILE_IMAGE] = ComponentDataParser.getComponentMobileImage;
      typesMap[DataType.VIDEO] = ComponentDataParser.getComponentVideo;
      typesMap[DataType.IFRAME] = ComponentDataParser.getComponentIframe;
      typesMap[DataType.HTML] = ComponentDataParser.getComponentHtml;
      typesMap[DataType.LINK] = ComponentDataParser.getComponentLink;
      typesMap[DataType.LIST] = ComponentDataParser.getComponentList;
      typesMap[DataType.TEXT] = ComponentDataParser.getComponentText;
      typesMap[DataType.SCREENING_TEST_LIST] = ComponentDataParser.getComponentScreeningTestList;
      typesMap[DataType.IMAGE_SPOT_LIST] = ComponentDataParser.getComponentImageSpotList;
      typesMap[DataType.NEWS_LIST_SPOT] = ComponentDataParser.getComponentNewsListSpot;
      typesMap[DataType.LINK_LIST] = ComponentDataParser.getComponentLinkList;
      typesMap[DataType.LANGUAGES_LIST] = ComponentDataParser.getComponentLanguagesList;
      typesMap[DataType.SEARCH] = ComponentDataParser.getComponentSearch;
      typesMap.headerContent = ComponentDataParser.getComponentHeaderContent;
      typesMap[DataType.BLOG_CATEGORIES] = ComponentDataParser.getComponentBlogCategories;
      typesMap[DataType.BLOG_LIST] = ComponentDataParser.getComponentBlogList;
      typesMap[DataType.RELATED_LIST] = ComponentDataParser.getComponentRelatedList;
      typesMap[DataType.NAVIGATION] = ComponentDataParser.getComponentHeaderNavigation;
      typesMap[DataType.SEARCH_FIELD_SPOT] = ComponentDataParser.getComponentSeachFieldSpot;
      typesMap[DataType.LANGUAGE_SELECTOR_SPOT] = ComponentDataParser.getComponentLanguageSelectorSpot;
      return typesMap[type](element);
    }
    /**
     * The returned object when DateType.IMAGE or DataType.MOBILE_IMAGE is used in a schema.
     * @typedef {object} DataTypeImage
     * @property {string} src
     * @property {string} alt
     * @property {string} height
     * @property {string} width
     */

    /**
      * @param {HTMLImageElement} image
      * @returns DataTypeImage
      */

  }, {
    key: "getComponentImage",
    value: function getComponentImage(image) {
      if (image.getAttribute('src')) {
        return {
          src: (0, _wdh.resolveImageSrc)(image),
          alt: image.alt || null,
          height: image.height || null,
          width: image.width || null
        };
      }

      if (image.getAttribute('data-src')) {
        return {
          src: image.getAttribute('data-src'),
          alt: image.alt || null,
          height: image.height || null,
          width: image.width || null
        };
      }

      return {
        src: null,
        alt: null,
        height: null,
        width: null
      };
    }
  }, {
    key: "getComponentMobileImage",
    value: function getComponentMobileImage(mobileImage) {
      if (typeof mobileImage.dataset.mobileImage !== 'undefined') {
        return {
          src: mobileImage.dataset.mobileImage,
          alt: mobileImage.dataset.mobileImageAltText || null,
          height: mobileImage.dataset.mobileImageHeight || null,
          width: mobileImage.dataset.mobileImageWidth || null
        };
      }

      return {
        src: null,
        alt: null,
        height: null,
        width: null
      };
    }
    /**
     * The returned object when DateType.VIDEO is used in a schema.
     * @typedef {object} DataTypeVideo
     * @property {string} src
     * @property {string} type
     */

  }, {
    key: "getComponentVideo",
    value: function getComponentVideo(video) {
      if (typeof video.src !== 'undefined') {
        return {
          src: video.src,
          type: video.type || null
        };
      }

      return {
        src: null,
        type: null
      };
    }
    /**
     * The returned object when DateType.IFRAME is used in a schema.
     * @typedef {object} DataTypeIframe
     * @property {string} src
     * @property {string} width
     * @property {string} height
     * @property {string} frameBorder
     */

  }, {
    key: "getComponentIframe",
    value: function getComponentIframe(iframe) {
      if (typeof iframe.src !== 'undefined') {
        return {
          src: iframe.src,
          width: iframe.width || null,
          height: iframe.height || null,
          frameBorder: iframe.frameborder || null
        };
      }

      return {
        src: null,
        width: null,
        height: null,
        frameBorder: null
      };
    }
    /**
     * The returned object when DateType.HTML is used in a schema.
     * @typedef {object} DataTypeHTML
     * @property {string} html
     */

    /**
      *
      * @param {HTMLElement} html
      * @returns DataTypeHTML
      */

  }, {
    key: "getComponentHtml",
    value: function getComponentHtml(html) {
      return {
        html: html.innerHTML || null
      };
    }
    /**
     * The returned object when DateType.LINK is used in a schema.
     * @typedef {object} DataTypeImage
     * @property {string} href
     * @property {string} content - the innerHTML of the link
     * @property {string} target
     * @property {string} title
     */

  }, {
    key: "getComponentLink",
    value: function getComponentLink(link) {
      return {
        href: link && link.href || null,
        content: link && link.innerHTML || null,
        target: link && link.target || null,
        title: link && link.title || null
      };
    }
    /**
     * The returned object when DateType.SEARCH is used in a schema.
     * @typedef {object} DataTypeImage
     * @property {string} resultPage
     * @property {string} restrictedChars
     */

  }, {
    key: "getComponentSeachFieldSpot",
    value: function getComponentSeachFieldSpot(spot) {
      return {
        resultPage: spot.getAttribute('data-result-page'),
        restrictedChars: spot.getAttribute('data-restricted-chars')
      };
    }
    /**
     * The returned object when DateType.LIST is used in a schema.
     * @typedef {array.<string>} DataTypeList
     */

  }, {
    key: "getComponentList",
    value: function getComponentList(list) {
      var listElements = list.querySelectorAll('ul,ol')[0];

      if (listElements !== undefined) {
        var elements = [];
        [].forEach.call(listElements.children, function (el) {
          elements.push(el.innerHTML);
        });
        return elements;
      }

      return null;
    }
    /**
     * The returned object when DateType.TEXT is used in a schema.
     * @typedef {object} DataTypeImage
     * @property {string} text
     */

  }, {
    key: "getComponentText",
    value: function getComponentText(element) {
      return {
        text: element.innerText || null
      };
    }
    /**
     * The returned object when DateType.SCREENING_TEST_LIST is used in a schema.
     * @typedef {Object} DataTypeImage
     * @property {Array.<Object>} questions
     * @property {string} questions.title
     * @property {string} questions.description
     * @property {Array.<Object>} questions.answers
     * @property {string} questions.answers.title
     * @property {string} questions.answers.value
     * @property {Array.<Object>} results
     * @property {string} results.title
     * @property {string} results.description
     * @property {number} results.minvalue
     * @property {number} results.maxvalue
     */

  }, {
    key: "getComponentScreeningTestList",
    value: function getComponentScreeningTestList(list) {
      var listElements = list.querySelectorAll('.questions ul')[0];
      var questionsAndResults = {
        questions: [],
        results: []
      };

      if (listElements !== undefined) {
        [].forEach.call(listElements.children, function (el) {
          if (el.classList.contains('screening-test-result-container')) {
            var resultsList = el.querySelectorAll('.screening-test-result');
            [].forEach.call(resultsList, function (result) {
              questionsAndResults.results.push({
                title: result.querySelector('h2').innerText,
                description: result.querySelector('.result-description').innerHTML,
                minValue: result.dataset.minScore,
                maxValue: result.dataset.maxScore
              });
            });
          } else {
            var question = {
              title: el.querySelector('h2').innerText,
              description: el.querySelector('.question-description').innerHTML,
              answers: []
            };
            var questionAnswers = el.querySelectorAll('.button');
            [].forEach.call(questionAnswers, function (answer) {
              question.answers.push({
                title: answer.innerText,
                value: answer.dataset.score
              });
            });
            questionsAndResults.questions.push(question);
          }
        });
      }

      return questionsAndResults;
    }
    /**
     * The returned object when DateType.IMAGE_SPOT_LIST is used in a schema.
     * @typedef {Array.<Object>} DataTypeImageSpotList
     * @property {DataTypeImage} image
     * @property {DataTypeImage} imageDescription
     * @property {string} header an HTML string
     * @property {string} text an HTML string
     * @property {string} contextContent an HTML string
     * @property {DataTypeLink} link
     * @property {string} sitecoreItem
     * @property {string} sitecoreChromeData
     */

  }, {
    key: "getComponentImageSpotList",
    value: function getComponentImageSpotList(list) {
      var listElements = list.querySelectorAll('li');
      var imageSpots = [];
      listElements.forEach(function (el) {
        var image = el.querySelector('.image-spot-element-image img');
        var imageDescription = el.querySelector('.image-spot-element-image-description');
        var header = el.querySelector('.image-spot-element-header');
        var text = el.querySelector('.image-spot-element-text');
        var contextContent = el.querySelector('.image-spot-element-context-content');
        var link = el.querySelector('.image-spot-element-link a');
        var sitecoreItem = el.querySelector('div[sc_item]');
        var sitecoreChromeData = el.querySelector('.scChromeData');
        var spot = {
          image: image === null ? null : ComponentDataParser.getComponentImage(image),
          imageDescription: imageDescription === null ? null : imageDescription.innerText,
          header: header === null ? null : header.innerHTML,
          text: text === null ? null : text.innerHTML,
          contextContent: contextContent === null ? null : contextContent.innerHTML,
          link: link === null ? null : ComponentDataParser.getComponentLink(link),
          sitecoreItem: sitecoreItem === null ? null : sitecoreItem.getAttribute('sc_item'),
          sitecoreChromeData: sitecoreChromeData === null ? null : sitecoreChromeData.textContent
        };
        imageSpots.push(spot);
      });
      return imageSpots;
    }
  }, {
    key: "getComponentNewsListSpot",
    value: function getComponentNewsListSpot(newsListSpot) {
      var listElements = newsListSpot.querySelectorAll('li');
      var elements = [];
      listElements.forEach(function (li) {
        var image = ComponentDataParser.getComponentImage(li.querySelector('.news-image img'));
        var header = li.querySelector('.news-header').innerHTML;
        var location = li.querySelector('.news-location').innerHTML;
        var date = li.querySelector('.news-date h4').innerHTML;
        var text = li.querySelector('.news-text').innerHTML;
        var link = li.querySelector('.news-link a');
        elements.push({
          image: image,
          header: header,
          location: location,
          date: date,
          text: text,
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "getComponentLinkList",
    value: function getComponentLinkList(linkList) {
      var listElements = linkList.querySelectorAll('li');
      var elements = [];
      listElements.forEach(function (li) {
        var link = li.querySelector('a');
        elements.push({
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "getComponentBlogCategories",
    value: function getComponentBlogCategories(blogCategories) {
      var listElements = blogCategories.querySelectorAll('a');
      var elements = [];
      listElements.forEach(function (el) {
        var link = ComponentDataParser.getComponentLink(el);
        elements.push({
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "getComponentBlogList",
    value: function getComponentBlogList(blogList) {
      var listElements = blogList.querySelectorAll('li');
      var elements = [];
      listElements.forEach(function (li) {
        var image = li.querySelector('.news-image img') || null;
        var title = li.querySelector('.news-title .link').innerHTML || null;
        var text = li.querySelector('.news-text').innerHTML || null;
        var date = li.querySelector('.news-date');
        if (date !== null) date = date.innerHTML;
        var link = li.querySelector('a') || null;
        var newsLink = li.querySelector('.news-link .link').innerHTML || null;
        elements.push({
          image: image,
          title: title,
          text: text,
          date: date,
          link: link,
          newsLink: newsLink
        });
      });
      return elements;
    }
  }, {
    key: "getComponentRelatedList",
    value: function getComponentRelatedList(relatedList) {
      var relatedElements = relatedList.querySelectorAll('li');
      var elements = [];
      relatedElements.forEach(function (li) {
        var image = li.querySelector('.news-image img');
        var date = li.querySelector('.news-date').innerHTML;
        var title = li.querySelector('.news-title').innerHTML;
        var text = li.querySelector('.news-text').innerHTML;
        var link = li.querySelector('a');
        var newsLink = li.querySelector('.news-link .link').innerHTML;
        elements.push({
          image: image,
          date: date,
          title: title,
          text: text,
          link: link,
          newsLink: newsLink
        });
      });
      return elements;
    }
  }, {
    key: "getComponentRelatedBlogs",
    value: function getComponentRelatedBlogs(authorRelatedBlogs) {
      var relatedElements = authorRelatedBlogs.querySelectorAll('li');
      var elements = [];
      relatedElements.forEach(function (li) {
        var image = li.querySelector('.author-blog-image img');
        var date = li.querySelector('.author-blog-date').innerHTML;
        var title = li.querySelector('.author-blog-title').innerHTML;
        var text = li.querySelector('.author-blog-text').innerHTML;
        var link = li.querySelector('a');
        var newsLink = li.querySelector('.author-blog-link .link').innerHTML;
        elements.push({
          image: image,
          date: date,
          title: title,
          text: text,
          link: link,
          newsLink: newsLink
        });
      });
      return elements;
    }
  }, {
    key: "getComponentLanguageSelectorSpot",
    value: function getComponentLanguageSelectorSpot(spot) {
      var languagesList = ComponentDataParser.getComponentLanguagesList(spot.querySelector('.component-content > ul'));
      var popupHeadline = ComponentDataParser.getComponentText(spot.querySelector('.component-content .popup__headline'));
      var popupLinks = [];
      spot.querySelectorAll('.component-content .popup__link').forEach(function (link) {
        popupLinks.push(ComponentDataParser.getComponentLink(link));
      });
      var prompt = !!spot.getAttribute('data-prompt');
      return {
        languagesList: languagesList,
        popupHeadline: popupHeadline,
        popupLinks: popupLinks,
        prompt: prompt
      };
    }
  }, {
    key: "getComponentLanguagesList",
    value: function getComponentLanguagesList(list) {
      var listElements = list.querySelectorAll('li');
      var languagesList = [];
      listElements.forEach(function (el) {
        var linkElement = el.querySelector('a');
        var link = ComponentDataParser.getComponentLink(linkElement);
        languagesList.push(link);
      });
      return languagesList;
    }
  }, {
    key: "getComponentSearch",
    value: function getComponentSearch(element) {
      return {
        searchUrl: element.dataset.resultPage || null
      };
    }
  }, {
    key: "getComponentHeaderContent",
    value: function getComponentHeaderContent(element) {
      var excludedClasses = ['image', 'search-field-spot', 'language-selector-spot', 'nav-expander'];
      var includedClasses = ['link', 'rich-text', 'navigation'];
      var regexClasses = "\\b(".concat(excludedClasses.join('|'), ")\\b");
      var regex = new RegExp(regexClasses, 'i');
      var components = element.querySelectorAll('.component');
      var content = [];
      components.forEach(function (com) {
        if (!regex.test(com.classList)) {
          includedClasses.forEach(function (ic) {
            if (com.classList.contains(ic)) {
              var componentData = null;

              switch (ic) {
                case 'link':
                  {
                    var linkSelector = com.querySelector('.component-content a');
                    var btnClassList = com.classList.value;
                    componentData = ComponentDataParser.getComponentLink(linkSelector);
                    componentData.type = 'link';

                    if (btnClassList !== null && btnClassList !== undefined) {
                      var btnMatch = btnClassList.match(/(header-btn-+\w+)/g);

                      if (btnMatch !== null) {
                        componentData.btnList = btnMatch.toString();
                      }
                    }

                    break;
                  }

                case 'rich-text':
                  {
                    var rteSelector = com.querySelector('.component-content');
                    var linkClassList = com.classList.value;
                    componentData = ComponentDataParser.getComponentHtml(rteSelector);
                    componentData.type = 'rich-text';

                    if (linkClassList !== null && linkClassList !== undefined) {
                      var listMatch = linkClassList.match(/(\w+-header)/g);

                      if (listMatch !== null) {
                        componentData.linkList = listMatch.toString();
                      }
                    }

                    break;
                  }

                case 'navigation':
                  {
                    var navSelector = com.querySelector('.component-content ul');
                    componentData = ComponentDataParser.getComponentHeaderNavigation(navSelector);
                    componentData.type = 'navigation';
                    break;
                  }

                default:
                  break;
              }

              content.push(componentData);
            }
          });
        }
      });
      return content;
    }
  }, {
    key: "getComponentHeaderNavigation",
    value: function getComponentHeaderNavigation(navigation) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var hookClass = ".level".concat(i);
      var currentNode = navigation.querySelectorAll("li".concat(hookClass));
      var globalNav = [];
      i += 1;
      currentNode.forEach(function (node) {
        var nav = {
          link: null,
          nestedLinks: []
        };
        var link = node.querySelector("li".concat(hookClass, " > a"));
        var nestedLinksUl = node.querySelector("li".concat(hookClass, " > ul"));
        nav.link = ComponentDataParser.getComponentLink(link);
        nav.nestedLinks = nestedLinksUl ? ComponentDataParser.getComponentHeaderNavigation(nestedLinksUl, i) : [];
        globalNav.push(nav);
      });
      return globalNav;
    }
  }]);

  return ComponentDataParser;
}();

var _default = ComponentDataParser;
exports["default"] = _default;